export default __webpack_public_path__ + "static/media/start_your_trial.fd18961f.svg";